import { createRouter, createWebHistory } from 'vue-router';

const router = createRouter({
  history: createWebHistory(),
  scrollBehavior: () => ({ top: 0 }),
  routes: [
    { path: '/', name: 'home', component: () => import('@/views/HomeView.vue') },
    { path: '/onboarding', name: 'onboarding', component: () => import('@/views/OnboardingView.vue'), meta: { hideNav: true } },
    { path: '/mood', name: 'mood', component: () => import('@/views/HomeView.vue') },
    { path: '/mood/calendar', name: 'mood-calendar', component: () => import('@/views/MoodCalendarView.vue') },
    { path: '/ai', name: 'ai', component: () => import('@/views/AiSessionsView.vue') },
    { path: '/ai/:sessionId', name: 'ai-chat', component: () => import('@/views/AiChatView.vue'), meta: { hideNav: true } },
    { path: '/goals', name: 'goals', component: () => import('@/views/GoalsView.vue') },
    { path: '/goals/new', name: 'goal-new', component: () => import('@/views/GoalFormView.vue'), meta: { hideNav: true } },
    { path: '/goals/:goalId/edit', name: 'goal-edit', component: () => import('@/views/GoalFormView.vue'), meta: { hideNav: true } },
    { path: '/goals/:goalId', name: 'goal-details', component: () => import('@/views/GoalDetailView.vue') },
    { path: '/archive', name: 'archive', component: () => import('@/views/ArchiveView.vue') },
    { path: '/subscription', name: 'subscription', component: () => import('@/views/SubscriptionView.vue') },
    { path: '/profile', redirect: '/' },
    { path: '/settings', name: 'settings', component: () => import('@/views/SettingsView.vue') },
    { path: '/settings/notifications', redirect: { path: '/settings', hash: '#notifications' } },
    { path: '/support', name: 'support', component: () => import('@/views/SupportView.vue') },
    { path: '/legal/:document', name: 'legal', component: () => import('@/views/LegalView.vue'), meta: { hideNav: true } },
    { path: '/:pathMatch(.*)*', redirect: '/' },
  ],
});

export default router;
